export const VARIANCES = {
  PERCENTAGE: 'percentage',
  ABSOLUTE: 'absolute',
  NONE: 'none',
} as const;

export type Variance = (typeof VARIANCES)[keyof typeof VARIANCES];

export function isVariance(value: unknown): value is Variance {
  return Object.values(VARIANCES).includes(value as Variance);
}
